module.exports = __webpack_public_path__ + "assets/up_logo.svg";


//////////////////
// WEBPACK FOOTER
// ./images/up_logo.svg
// module id = 157
// module chunks = 0